export default {
	getTypeById(ids, cb, ecb, config) {
		this.http
			.get(`/room/getTypeById/${ids}`, config)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	searchType(params, cb, ecb, prof = 'default') {
		this.http
			.get(`/room/searchType/${prof}`, {
				params
			})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	updateType(form, cb, ecb) {
		this.http
			.post('/room/updateType', form)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	getFacilityById(ids, cb, ecb, config) {
		this.http
			.get(`/room/getFacilityById/${ids}`, config)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	searchFacility(params, cb, ecb) {
		this.http
			.get('/room/searchFacility', {
				params
			})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	updateFacility(form, cb, ecb = null) {
		this.http
			.post('/room/updateFacility', form)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	removeFacility(id, cb, ecb = null) {
		this.http
			.get(`/room/removeFacility/${id}`)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	getSKUs(id, cb, ecb) {
		this.http
			.get(`/room/getSKUs/${id}`)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	getStocks(skuid, cb, ecb) {
		this.http
			.get(`/room/getStocks/${skuid}`)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	checkoutConfirm(form, cb, ecb) {
		this.http
			.post(`/room/checkoutConfirm`, form)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	searchOrder(params, cb, ecb) {
		this.http
			.get('/room/searchOrder/', {
				params
			})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	}
}
